import styled from '@emotion/styled';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import plus from '@/images/plus.svg';

const AddFrameContainer = styled.div`
    width: 150px;
    height: 120px;
    cursor: pointer;
`;
const AddFrameInner = styled.div`
    width: 150px;
    height: 85px;
    opacity: 0.8;

    border: 1px solid #7c7c7a;
    box-shadow: -2px 2px 7px rgba(0, 0, 0, 0.25);
    border-radius: 8px;

    border-radius: 8px;
    padding: 3px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default function ({ onClick }: { onClick: () => void }) {
    return (
        <AddFrameContainer onClick={onClick}>
            <AddFrameInner>
                <MaskedIcon src={plus} size="1.8rem" color="#7C7C7A" />
            </AddFrameInner>
        </AddFrameContainer>
    );
}
